module.exports = __webpack_public_path__ + "img/cupcake-5.51e46957.svg";